import { isWithinInterval } from "date-fns";

export const getDayLabel = (activeEpochId: number, epochStart: Date, epochEnd: Date) => {
  const label = `Epoch #${activeEpochId + 1}`;
  if (isWithinInterval(new Date(), { start: epochStart, end: epochEnd })) return label + " (today)";
  return label;
};
